import { render, staticRenderFns } from "./guestFeatureRequest.vue?vue&type=template&id=3b7e2b33&scoped=true&"
import script from "./guestFeatureRequest.vue?vue&type=script&lang=js&"
export * from "./guestFeatureRequest.vue?vue&type=script&lang=js&"
import style0 from "./guestFeatureRequest.vue?vue&type=style&index=0&id=3b7e2b33&lang=scss&scoped=true&"
import style1 from "./guestFeatureRequest.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7e2b33",
  null
  
)

export default component.exports